export default {
    install(Vue, options) {
        Vue.prototype.$notify = function (message, options, flashOptions) {
            if(this.$auth.watch?.data?.disabled_notifications) {
                return;
            }
            if(typeof options === 'string') {
                this.flash(message, options, flashOptions)
            } else {
                this.$bvToast.toast(message, options)
            }
        }
    }
}